var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#03A9F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2096 26.007C22.8703 26.007 25.9658 21.3173 25.9658 17.2508C25.9658 17.1176 25.9631 16.9849 25.9571 16.853C26.558 16.4186 27.0802 15.8764 27.4923 15.2593C26.9409 15.5045 26.3473 15.6694 25.7249 15.744C26.3603 15.3628 26.8481 14.7601 27.0782 14.0417C26.4836 14.3942 25.825 14.6503 25.124 14.7887C24.5624 14.1905 23.7628 13.8164 22.8775 13.8164C21.1781 13.8164 19.7998 15.1946 19.7998 16.8935C19.7998 17.1351 19.8269 17.3699 19.8796 17.5952C17.3219 17.4665 15.0537 16.242 13.536 14.3798C13.2718 14.8345 13.1194 15.3629 13.1194 15.9267C13.1194 16.9943 13.6627 17.937 14.4888 18.4883C13.9839 18.4728 13.5097 18.3342 13.095 18.1035C13.0946 18.1164 13.0946 18.129 13.0946 18.1427C13.0946 19.6332 14.1554 20.8776 15.5637 21.1596C15.305 21.23 15.0329 21.2679 14.7522 21.2679C14.5542 21.2679 14.3612 21.2484 14.1737 21.2124C14.5655 22.4352 15.7017 23.3249 17.0487 23.3499C15.9953 24.1755 14.6684 24.6673 13.2263 24.6673C12.9783 24.6673 12.7331 24.653 12.4922 24.6246C13.8542 25.4976 15.4715 26.0071 17.2097 26.0071",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/tw.bae2256e11070bcb0f018bbc3a1ecc38.svg";
export { ForwardRef as ReactComponent };